import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { IssuableAllCouponType } from '../../@types/coupon'
import { postCouponNoDownload } from '../../api/coupons'
import { getFestivalTypeAcc, getWelcome, postFestivalTypeAcc, postWelcome } from '../../api/login'
import { handlePostMessage } from '../../js/postMessage'
import { plusComma } from '../../js/script'
import { imgURL } from '../../pages/Home'
import { useCommonContext } from '../provider/CommonProvider'
import { useMyContext } from '../provider/MyProvider'
import { useAppContext } from '../provider/AppProvider'

const FestivalCoupon = ({
  element,
  idx,
  userData,
  allDownloadCoupons,
  allDownloadableCoupons,
  setAllDownloadableCoupons,
  setCouponStateChange,
  couponStateChange,
  couponData,
  setSelectCouponArray,
  setCheckDownload,
  checkDownload,
  setStateChange,
  setDownLoadCheck,
  memberCheckPoint,
  festivalId,
}: any) => {
  const [couponUsed, setCouponUsed] = useState(false)
  const [selectCoupon, setSelectCoupon] = useState<IssuableAllCouponType | null>(null)
  const param = useParams()
  const { setToastMessage, setToastBtnMessage, setToastEvent, setIsToast } = useMyContext()
  const { setIsLogin, hasAccessToken } = useCommonContext()
  const { isAppView } = useAppContext()

  useEffect(() => {
    setCheckDownload((prev: any) => [...prev, { id: idx, couponCheck: couponUsed }])
  }, [])

  useEffect(() => {
    const array: any = []
    if (checkDownload.length !== 0) {
      for (let i = 0; i < checkDownload.length; i++) {
        if (i === idx) {
          checkDownload[i].couponCheck = couponUsed
          array.push(checkDownload[i])
        } else {
          array.push(checkDownload[i])
        }
      }
      setDownLoadCheck(array)
    }
  }, [checkDownload, couponUsed])

  useEffect(() => {
    if (hasAccessToken) {
      if (element.type === 'welcome') {
        if (memberCheckPoint) {
          getWelcome().then((res) => {
            if (res.data.accumulation) {
              setCouponUsed(true)
            } else {
              setCouponUsed(false)
            }
          })
        } else {
          setCouponUsed(true)
        }
      } else if (element.type === 'coupon') {
        // const text = element.title

        // 정규식을 이용해 기간을 추출
        // const dateRegex = /(\d{2}\/\d{2})~(\d{2}\/\d{2})/;
        // const match = text.match(dateRegex);

        // if (match) {
        //   const startDateText = match[1]; // 10/07
        //   const endDateText = match[2]; // 10/19

        //   // 현재 날짜 가져오기
        //   const currentDate = new Date();

        //   // 날짜를 MM/DD 형식에서 Date 객체로 변환
        //   const startDate = parse(startDateText, 'MM/dd', currentDate);
        //   const endDate = parse(endDateText, 'MM/dd', currentDate);

        //   // 현재 날짜가 기간 내에 포함되는지 확인
        //   const isWithinPaymentPeriod = isWithinInterval(currentDate, {
        //     start: startDate,
        //     end: endDate,
        //   });

        //   setIsWithinPaymentPeriod(isWithinPaymentPeriod);
        // } else {
        //   console.log('기간 정보를 찾을 수 없습니다.');
        // }

        couponData.map((el: any) => {
          if (el.couponNo === element.no) {
            setSelectCoupon(el)
          }
        })
      } else if (element.type === 'ad-hoc') {
        if (param.url !== undefined) {
          getFestivalTypeAcc(festivalId, element.accumulationType)
            .then((res) => {
              if (res.data.accumulation) {
                setCouponUsed(true)
              } else {
                setCouponUsed(false)
              }
            })
            .catch((err) => {
              console.log(err)
            })
        }
      }
    }
  }, [element, allDownloadCoupons, couponUsed, couponData, memberCheckPoint, hasAccessToken, couponStateChange])

  useEffect(() => {
    if (selectCoupon) {
      if (selectCoupon.downloadable) {
        setCouponUsed(false)
      } else {
        setCouponUsed(true)
      }
    }
  }, [selectCoupon, couponStateChange, couponUsed, couponData])

  useEffect(() => {
    if (selectCoupon) {
      setAllDownloadableCoupons((prev: any) => [...prev, selectCoupon.couponNo])
    }
  }, [selectCoupon, couponUsed, couponData, couponStateChange])

  useEffect(() => {
    if (selectCoupon && selectCoupon.downloadable) {
      const matchingCoupons = allDownloadableCoupons.filter((el: any) => el === selectCoupon.couponNo)
      if (matchingCoupons.length > 0) {
        setSelectCouponArray((prev: any) => [...prev, ...matchingCoupons])
      }
    }
  }, [allDownloadableCoupons, couponUsed, selectCoupon])

  return (
    <li key={idx} className={couponUsed ? 'used' : ''}>
      <button
        onClick={() => {
          if (hasAccessToken) {
            if (!couponUsed) {
              if (element.type === 'ad-hoc') {
                postFestivalTypeAcc(Number(userData.memberNo), festivalId, element.accumulationType).then((res) => {
                  setStateChange((prev: any) => !prev)
                  setTimeout(() => {
                    setCouponUsed(true)
                    setIsToast(true)
                    setToastMessage('적립금을 지급받았습니다.')
                  }, 200)
                })
              } else if (element.type === 'welcome') {
                postWelcome().then((res) => {
                  setStateChange((prev: any) => !prev)
                  setTimeout(() => {
                    setCouponUsed(true)
                    setIsToast(true)
                    setToastMessage('적립금을 지급받았습니다.')
                  }, 200)
                })
              } else if (element.type === 'coupon') {
                postCouponNoDownload(element.no)
                  .then((res) => {
                    setStateChange((prev: any) => !prev)
                    setTimeout(() => {
                      setCouponUsed(true)
                      setCouponStateChange((prev: boolean) => !prev)
                      setIsToast(true)
                      setToastMessage('쿠폰을 발급받았습니다.')
                    }, 200)
                  })
                  .catch((err) => {
                    const errorMessage = err.response?.data?.message
                    if (errorMessage === '할인쿠폰 발급이 종료되었습니다.') {
                      setIsToast(true)
                      setToastMessage('발급 가능한 기간이 아닙니다.')
                    }
                  })
              }
            } else {
              if (element.type === 'ad-hoc') {
                setIsToast(true)
                setToastMessage('이미 적립금을 받으셨습니다.')
              } else if (element.type === 'welcome') {
                if (!memberCheckPoint) {
                  setIsToast(true)
                  setToastMessage('기존 회원은 발급받을 수 없습니다.')
                } else {
                  setIsToast(true)
                  setToastMessage('이미 적립금을 받으셨습니다.')
                }
              } else if (element.type === 'coupon') {
                setIsToast(true)
                setToastMessage('이미 쿠폰을 받으셨습니다.')
              }
            }
          } else {
            setIsToast(true)
            setToastMessage('로그인이 필요한 서비스입니다.')
            setToastBtnMessage('로그인')
            setToastEvent(() => () => {
              if (isAppView) {
                handlePostMessage({ actionType: 'onSignInInducement' })
              } else {
                setIsLogin(true)
              }
            })
          }
        }}
        style={{
          backgroundColor: couponUsed ? 'var(--colGray1)' : element.type === 'coupon' ? '#ffffff' : '#fffcf2',
        }}
      >
        <p className='benefit_title'>
          {element.type === 'coupon' ? '할인쿠폰' : element.type === 'welcome' ? '신규회원 적립금' : '쇼핑적립금'}
        </p>
        <p className='benefit_cont_txt'>{element.title}</p>
        <div className='download_wrap'>
          <p
            className='benefit_price'
            style={{
              color: couponUsed ? 'var(--colGray5)' : element.type === 'coupon' ? 'var(--colPointBlue' : '#f8A618',
            }}
          >
            {element?.discountAmt ? `${plusComma(element?.discountAmt)}원` : `${element?.discountPercent}%`}
          </p>
          <p className='benefit_download'>
            {couponUsed ? (
              <img src={`${imgURL}/icon_benefit_download_gray.png`} alt='' />
            ) : (
              <img src={`${imgURL}/icon_benefit_download.png`} alt='' />
            )}
          </p>
        </div>
        {/* <p>{element.price}</p> */}
      </button>
    </li>
  )
}

export default FestivalCoupon
